import { render, staticRenderFns } from "./RuleBlockForSelectCategoryCard.vue?vue&type=template&id=bc49dd52&scoped=true&"
import script from "./RuleBlockForSelectCategoryCard.vue?vue&type=script&lang=js&"
export * from "./RuleBlockForSelectCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./RuleBlockForSelectCategoryCard.vue?vue&type=style&index=0&id=bc49dd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc49dd52",
  null
  
)

export default component.exports